import { render } from "./AcceptanceApprovalHistoryPageList.vue?vue&type=template&id=2e2f918d&scoped=true"
import script from "./AcceptanceApprovalHistoryPageList.vue?vue&type=script&lang=ts"
export * from "./AcceptanceApprovalHistoryPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2e2f918d"

export default script